import type {
  DownloadPaymentDetailRequestDTO,
  PaymentInvoiceDetailPrevDTO,
  PaymentInvoiceHistoryPrevResponse,
  PaymentListRequest,
} from '../../types/previdencia/previdenciaType';
import { PREVIDENCIA_DIGITAL_INVOICING_ROUTES } from '../requestsService';

export class DigitalInvoicingService {
  private fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Download payment detail
   * Matches backend endpoint: POST /v1/bff/previdencia/payments/download
   * @param request - Download request data with invoiceId
   */
  async downloadPaymentDetail(request: DownloadPaymentDetailRequestDTO): Promise<void> {
    return this.fetch<void>(PREVIDENCIA_DIGITAL_INVOICING_ROUTES.POST_PAYMENT_DOWNLOAD, {
      method: 'POST',
      body: JSON.stringify(request),
    });
  }

  /**
   * Get payments (paginated)
   * Matches backend endpoint: GET /v1/bff/previdencia/payments
   * Returns PaymentInvoiceHistoryPrevResponse (PageResponse<PaymentInvoiceHistoryPrevDTO>)
   * @param params - Request parameters
   */
  async getPayments(params: PaymentListRequest): Promise<PaymentInvoiceHistoryPrevResponse> {
    const queryParams = new URLSearchParams();

    queryParams.append('companyId', params.companyId);
    queryParams.append('subCompanyId', params.subCompanyId);

    if (params.emissionFrom) {
      queryParams.append('emissionFrom', params.emissionFrom);
    }
    if (params.emissionTo) {
      queryParams.append('emissionTo', params.emissionTo);
    }
    if (params.page !== undefined) {
      queryParams.append('page', params.page.toString());
    }
    if (params.size !== undefined) {
      queryParams.append('size', params.size.toString());
    }

    const url = `${PREVIDENCIA_DIGITAL_INVOICING_ROUTES.GET_PAYMENTS}?${queryParams.toString()}`;

    return this.fetch<PaymentInvoiceHistoryPrevResponse>(url, {
      method: 'GET',
    });
  }

  /**
   * Get payment detail
   * Matches backend endpoint: GET /v1/bff/previdencia/payments/detail
   * Returns PaymentInvoiceDetailPrevDTO (specific for Previdência)
   * @param invoiceId - Invoice ID (fatura ID)
   */
  async getPaymentDetail(
    invoiceId: number
  ): Promise<PaymentInvoiceDetailPrevDTO> {
    const url = `${PREVIDENCIA_DIGITAL_INVOICING_ROUTES.GET_PAYMENT_DETAIL}?invoiceId=${encodeURIComponent(invoiceId)}`;

    return this.fetch<PaymentInvoiceDetailPrevDTO>(url, {
      method: 'GET',
    });
  }
}

